/**
 * 라이브 스트림 재생 URL 조립.
 *
 * 재생 소스가 없으면 "" 를 반환한다. 예전에는 4개 템플릿에 같은 삼항식이 복사돼 있었고
 * 두 가지 결함이 있었다.
 *
 * 1. urlKeyUrl 이 null 이면 `consoleCfg?.urlKeyUrl?.indexOf(...)` 가 undefined 이고
 *    `undefined != -1` 이 true 라서 참 분기를 타 문자열 "null" 이 URL 이 됐다.
 * 2. 쿼리스트링을 삼항식 안과 밖에서 두 번 붙여 `?a=1&b=2?a=1&b=2` 가 됐다.
 *    (첫 사본의 마지막 파라미터 값에 `?...` 가 섞여 logKey 가 오염된다)
 *
 * 두 결함이 겹쳐 채널 미할당 상태에서 `/null?...?...` 요청이 나갔고,
 * 자동 재생 인터벌이 이를 5초마다 반복했다.
 */
export const buildLiveStreamUrl = (consoleCfg = {}, queryStr = "") => {
  const endPoint = consoleCfg.consoleEndPoint;

  // NCloud 미디어센터: END_POINT 에 naverncp.com HLS URL 이 저장된 경우 그대로 사용(쿼리스트링 제외)
  if (typeof endPoint === "string" && endPoint.startsWith("https")) {
    return endPoint;
  }

  if (consoleCfg.consoleHdServerIdx == 10) {
    if (!consoleCfg.cfUrl || !endPoint) return "";
    return `${consoleCfg.cfUrl}${endPoint}/index.m3u8${queryStr}`;
  }

  const keyUrl = consoleCfg.urlKeyUrl;
  if (!keyUrl || typeof keyUrl !== "string") return "";

  const pageProtocol = typeof window !== "undefined" && window.location
    ? window.location.protocol
    : "https:";

  // urlKeyUrl 이 페이지와 다른 프로토콜이면 페이지 프로토콜로 맞춘다(mixed content 방지)
  const base = keyUrl.indexOf(pageProtocol) !== -1
    ? keyUrl
    : keyUrl.replace(keyUrl.slice(0, keyUrl.indexOf(":") + 1), pageProtocol);

  return `${base}${queryStr}`;
};

/** primaryUrl 이 비어 있으면 backup 도 만들지 않는다("&backup=true" 단독 요청 방지) */
export const buildLiveBackupUrl = (primaryUrl) =>
  primaryUrl ? `${primaryUrl}&backup=true` : "";
